import { render } from "./DatasetSegmentsQuestionnaire.vue?vue&type=template&id=01afc7f8"
import script from "./DatasetSegmentsQuestionnaire.vue?vue&type=script&lang=js"
export * from "./DatasetSegmentsQuestionnaire.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__